<template>
  <div class="main-container">
    <main-header></main-header>
    <testPortalBanner v-if="isTestPortal"></testPortalBanner>
    <sideMenu :studyData="studyData" :isTestPortal="isTestPortal"></sideMenu>
    <div class="has-header has-sidemenu form-container" :class="{ 'has-test-portal-header': isTestPortal }">
      <router-view :studyData="studyData" :studyId="studyId"></router-view>
    </div>
  </div>
</template>

<script>
import mainHeader from "../../components/common/main-header";
import sideMenu from "../../components/common/side-menu";
import testPortalBanner from "../../components/common/test-portal-banner";
import localStorageService from "@/services/localStorage";

export default {
  name: "data-capture-form",
  components: { mainHeader, sideMenu, testPortalBanner },
  data() {
    return {
      studyData: {},
      studyId: this.$route.params.studyId
    };
  },
  computed: {},
  methods: {
    getStudyDetails() {
      try {
        this.studyData = localStorageService.getItem("studyDetailsData")[this.studyId] || {};
      } catch (e) {
        console.error(e);
        this.studyData = {};
      }
    }
  },
  mounted() {
    this.getStudyDetails();
  },
  props: {
    isTestPortal: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.main-container {
  display: flex;
  background-color: #f5f6f7 !important;
  height: 100vh;
}

.has-header {
  margin-top: 90px;
}

.has-sidemenu {
  margin-left: 20px !important;
  padding-top: 0px !important;
}

.form-container {
  width: 100%;
}
</style>
